import React, { useEffect, useState } from "react";
import FooterWrapper from "./Footer.style";
import { Button } from "primereact/button";
import DownArrow from "../../assets/images/icons/vectorarrow.svg";
import DoubleUpArrow from "../../assets/images/icons/icon_double-up-arrow.svg";
import arrow from "../../assets/images/icons/arrow.svg";
import arrow_back from "../../assets/images/icons/arrow_back.svg";
import petromin from "../../assets/images/icons/mbi/arrow-bck-petromin.svg";
import nextArrow from "../../assets/images/next-arrow.svg";
//import { set_active_step } from "../../redux/actions/sidebarCommonActions";
//import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
//import config from "../../application/motor/helpers/config";
import PropTypes from "prop-types";
import Summary from "_shared/Summary/Summary";
import tamara from "assets/images/tamara.svg";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";
import ArrowIcon from "assets/images/icons/components/ArrowIcon";
import VectorIcon from "assets/images/icons/components/Vector";

const RightFooter = ({
  showTotalPrice,
  totalPrice,
  totalPriceSar,
  disableNext,
  showProporalSection,
  proposalSummary,
  disableNextBtn,
  showSummary,
  motorSummary,
  showNextBtn,
  nextBtnLabel,
  hideTPL,
  detailsDisc,
  nextBtnHandler = () => false,
  showTamaraSplit,
  showBackBtn,
  backBtnLabel,
  backBtnHandler = () => false,
  rightFooterPay,
  totalPriceValue,
  width = "",
}) => {
  const { i18n, t } = useTranslation();
  const { businessLine } = useParams();
  const showRTL = i18n.dir() === "rtl";
  const [summaryModal, showSummaryModal] = useState(false);
  const currentLanguageCode = i18n.language;
  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF;
  else if (businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC;
  else if (businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID;
  else if (businessLine === BUSINESS_LINE_PATHS.CARTRUST)
    businessColor = BUSINESS_LINE_COLORS.CARTRUST;
  else if (businessLine === BUSINESS_LINE_PATHS.SYARAH) businessColor = BUSINESS_LINE_COLORS.SYARAH;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.ALNAGHI)
    businessColor = BUSINESS_LINE_COLORS.ALNAGHI;
  else if (businessLine === BUSINESS_LINE_PATHS.LEAN) businessColor = BUSINESS_LINE_COLORS.LEAN;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.PETROMIN)
    businessColor = BUSINESS_LINE_COLORS.PETROMIN;

  const handleBack = () => {
    showSummaryModal(false);
    backBtnHandler();
  };
  const handleNext = () => {
    showSummaryModal(false);
    nextBtnHandler();
  };
  return (
    <FooterWrapper className={showRTL ? "ar" : ""}>
      {summaryModal && (
        <div className="overlaySummary" onClick={(e) => showSummaryModal(false)}>
          .
        </div>
      )}
      <div
        className={showRTL ? "bottom-box-summary-rtl" : "bottom-box-summary"}
        style={
          window.innerWidth > 660 ? { width: `${width ? `calc(100vw - ${width})` : "69%"}` } : {}
        }
      >
        <div className="container d-none d-sm-block">
          {summaryModal && (
            <Summary motorSummary={motorSummary} proposalSummary={proposalSummary} />
          )}
          <div className="row">
            {showSummary && (
              <div className="col-6">
                <div className="d-flex">
                  {!totalPriceValue && (
                    <div className="float-right">
                      <Button
                        className="vector-button"
                        onClick={() => {
                          showSummary && showSummaryModal(!summaryModal);
                        }}
                      >
                        <span>
                          {summaryModal ? (
                            <img src={DownArrow} alt="vector" />
                          ) : (
                            <VectorIcon color={businessColor} />
                          )}
                        </span>
                      </Button>
                    </div>
                  )}
                  <div className="ml-2">
                    <div className="summary">{i18n.t("RIGHTFOOTER.SUMMARY")}</div>
                    {showTotalPrice && (
                      <div className={showRTL ? "sar-rtl fm-tawuniya" : "sar fm-tawuniya"}>
                        {Number(totalPrice || totalPriceValue).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })}
                        <span> {totalPriceSar} </span>
                        {showTamaraSplit && (
                          <>
                            <span>&nbsp;|&nbsp;</span>
                            <span>
                              {i18n.t("PAYMENT.6SPLIT")} <span className="fm-tawuniya">3</span>{" "}
                              {i18n.t("PAYMENT.6SPLIT2")}{" "}
                              <span className="fm-tawuniya">{Math.round(+totalPrice / 3)}</span>{" "}
                              {t("RIGHTFOOTER.SAR")} <img src={tamara} />
                            </span>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {!summaryModal && (
              <div className="col d-flex justify-content-end">
                {showBackBtn && (
                  <Button
                    className={businessLine ? `back back-${businessLine}` : "back"}
                    type="submit"
                    onClick={handleBack}
                    style={{ marginRight: "1rem" }}
                  >
                    {businessLine === BUSINESS_LINE_PATHS.PETROMIN ? (
                      <img src={petromin} alt="Back arrow" />
                    ) : (
                      <img src={arrow_back} alt="Back arrow" />
                    )}
                    {backBtnLabel || i18n.t("RIGHTFOOTER.BACK")}
                  </Button>
                )}
                {showNextBtn && (
                  <Button
                    className={
                      businessLine ? `button-next button-next-${businessLine}` : "button-next"
                    }
                    type="submit"
                    disabled={disableNextBtn}
                    onClick={nextBtnHandler}
                    style={{ marginRight: "1rem" }}
                  >
                    {nextBtnLabel}
                    <img
                      className={`${currentLanguageCode === "ar" ? "flip" : "not-flip"}`}
                      src={nextArrow}
                      alt="arrow"
                    />
                  </Button>
                )}
              </div>
            )}
          </div>
          {summaryModal && (
            <>
              {!hideTPL && (
                <div className="row">
                  <div className="col-12">
                    <hr />
                    {/* <p className="">
                                            <img src={questionBottom} alt="bottom-img" />{" "}
                                            {t("Unlimited_Third_party_liability")}{" "}
                                        </p> */}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className="mobile-section d-block d-sm-none">
          {summaryModal && (
            <div className={"summary_wrapper"}>
              <Summary motorSummary={motorSummary} proposalSummary={proposalSummary} />
            </div>
          )}
          {showSummary && (
            <div
              className={"d-flex summary_mobile" + (summaryModal ? " opened" : "")}
              onClick={() => {
                showSummary && !totalPriceValue && showSummaryModal(!summaryModal);
              }}
            >
              <span>{i18n.t("RIGHTFOOTER.TOTAL")}</span>
              {showTotalPrice && (
                <>
                  <span className="fm-tawuniya price_value">
                    {Number(totalPrice || totalPriceValue).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  <span> {totalPriceSar} </span>
                </>
              )}
              <img className={summaryModal ? "rotate" : ""} src={DoubleUpArrow} alt="vector" />
            </div>
          )}
          <div
            className={
              currentLanguageCode === "ar"
                ? "d-flex button_wrapper  flex-row-reverse"
                : "d-flex button_wrapper "
            }
          >
            {showBackBtn && (
              <div>
                <Button type="button" className="vector-button mx-2 back-mb" onClick={handleBack}>
                  {/* <img src={arrow} alt="arrow" /> */}
                  <ArrowIcon color={businessColor} />
                </Button>
              </div>
            )}
            {/* <div>
              <Button type="button" className="rotate-button">
                <img src={rotateIcon} alt="Rotate Icon" className="orange" />
              </Button>
            </div> */}
            {showNextBtn && (
              <div className="grow-button">
                <Button
                  className={
                    businessLine ? `button-save button-save-${businessLine}` : "button-save"
                  }
                  type="submit"
                  onClick={handleNext}
                  disabled={disableNextBtn}
                >
                  {nextBtnLabel}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </FooterWrapper>
  );
};
RightFooter.PropsTypes = {
  totalPrice: PropTypes.number.isRequired,
  showTotalPrice: PropTypes.bool,
  showProporalSection: PropTypes.bool,
  proposalSummary: PropTypes.exact(
    {
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      category: PropTypes.oneOf(["tax", "summary"]),
    }.isRequired
  ),
  showSummary: PropTypes.bool,
  showNextBtn: PropTypes.bool,
  nextBtnHandler: PropTypes.func,
  nextBtnLabel: PropTypes.string,
  showBackBtn: PropTypes.bool,
  backBtnHandler: PropTypes.func,
  backBtnLabel: PropTypes.string,
  disableNext: PropTypes.bool,
  hideTPL: PropTypes.bool,
  showTamaraSplit: PropTypes.bool,
  detailsDisc: PropTypes.bool,
  motorSummary: PropTypes.exact({
    code: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    category: PropTypes.oneOf(["tax", "summary"]),
  }),
};
export default withTranslation()(RightFooter);
